import { render, staticRenderFns } from "./OrderHeaderActions.vue?vue&type=template&id=3d992450&"
import script from "./OrderHeaderActions.vue?vue&type=script&lang=ts&"
export * from "./OrderHeaderActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports